import { type } from 'arktype';
import { ref } from 'vue';

const ProductGid = type('string').pipe.try((s: string): number => {
  return Number.parseInt(s.replace('gid://shopify/Product/', ''), 10);
}, type('number'));

const CardCollection = type({
  label: 'string',
  products: ProductGid.array(),
}).pipe.try(
  (cardCollection) => ({
    ...cardCollection,
    slug: cardCollection.label.replaceAll(' ', '-').toLowerCase(),
  }),
  type({
    label: 'string',
    products: 'number[]',
    slug: 'string',
  }),
);

const Settings = type({
  default_checked_tag: 'string',
  collection_groups: CardCollection.array(),
  show_no_card: 'boolean',
  no_card_button_label: 'string',
});

const parseSettings = type('string').pipe.try((s: string): Settings => JSON.parse(s), Settings);

export type Settings = typeof Settings.infer;

export function useSettings() {
  const settings = ref<Settings | null>(null);

  function refreshSettings() {
    const settingsScript = document.querySelector<HTMLScriptElement>('#pick-a-card-settings');
    const parsedSettings = parseSettings(settingsScript?.textContent ?? '{}');
    if (parsedSettings instanceof type.errors) {
      console.warn(parsedSettings.flatProblemsByPath);
      settings.value = null;
    } else {
      settings.value = parsedSettings;
    }
  }

  return { settings, refreshSettings };
}
